import React from 'react';
import { Button, Popconfirm } from 'antd';

const Driver = ({ driver, deleteDriver }) => {
  const confirm = () => {
    deleteDriver(driver)
  };

  const cancel = (e) => {
    console.log('Click on No');
  };

  return (
    <div className='driver-item'>
      <div className='driver-item__cell'>
        { driver.username }
      </div>
      <div className='driver-item__cell'>
        { driver.email }
      </div>
      <div className='driver-item__cell driver-item__cell--controls'>
        <Popconfirm
          title='Удалить водителя'
          description={`Вы уверены что хотите удалить водителя: ${driver.username}`}
          onConfirm={confirm}
          onCancel={cancel}
          okText="Удалить"
          cancelText="Отмена"
        >
          <Button danger>Удалить</Button>
        </Popconfirm>
      </div>
    </div>
  )
}

export default Driver;